import { __makeTemplateObject } from "tslib";
import { styled } from '../../../foundation';
export var Mask = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  outline: none;\n"], ["\n  display: inline-block;\n  outline: none;\n"])));
var templateObject_1;
